import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appv2-image-popup',
  templateUrl: './image-popup.component.html',
  styleUrls: ['./image-popup.component.scss']
})
export class ImagePopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
